<template>
    <b-container fluid style="margin-top: 60px">
        <div class="form-inline">
            <h1 v-on:click="flipTreated">
                {{ title }} &nbsp;
                <b-button>
                    {{ btnTekst }}
                </b-button>
            </h1>
        </div>

        <div>
            <b-row>
                <b-col sm="8">
                    <period-selector
                        v-model="selectDays"
                        v-bind:periodDays="periodeDagen"
                        @change="setNewDates"
                    />
                </b-col>
                <b-col sm="3">
                    <b-row>
                        <b-col sm="11">
                            <b-button
                                @click="reloadData()"
                                class="bgc_aux_normal"
                                v-b-tooltip.hover
                                :title="$t('com_showdata', { ns: 'common' })"
                                ><font-awesome-icon
                                    icon="arrow-down"
                                    size="1x"
                                />
                            </b-button>
                            &nbsp;
                            <b-button
                                @click="scan()"
                                class="bgc_aux_unimportant"
                                ><font-awesome-icon icon="barcode" size="1x" />
                            </b-button>
                        </b-col>
                        <b-col sm="1"> </b-col>
                    </b-row>
                </b-col>
                <b-col sm="1">
                    <b-row class="float-right">
                        <b-col sm="11"> </b-col>
                        <b-col sm="1"> </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col sm="12">
                <div v-if="showFilter">
                    <b-row no-gutters>
                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_filter', { ns: 'common' })"
                                label-for="filter-input"
                                label-cols-sm="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-input-group size="sm">
                                    <b-form-input
                                        id="filter-input"
                                        v-model="filter"
                                        type="search"
                                        :placeholder="
                                            $t('com_typetosearch', {
                                                ns: 'common'
                                            })
                                        "
                                    ></b-form-input>

                                    <b-input-group-append>
                                        <b-button
                                            :disabled="!filter"
                                            @click="filter = ''"
                                            >{{
                                                $t('com_wis', { ns: 'common' })
                                            }}</b-button
                                        >
                                    </b-input-group-append>
                                </b-input-group>

                                <!--                                 <b-input-group size="sm">
                                    <b-button
                                        v-if="
                                            !treated &&
                                            checkRight('DeliveryCreate')
                                        "
                                        size="sm"
                                        @click="createNewItem"
                                        class="mr-1"
                                        ><font-awesome-icon
                                            icon="folder-plus"
                                            size="1x"
                                        />
                                        Extra behandeling
                                    </b-button>
                                </b-input-group> -->
                            </b-form-group>
                        </b-col>

                        <b-col lg="6" class="my-1">
                            <b-form-group
                                :label="$t('com_perpagina', { ns: 'common' })"
                                label-for="per-page-select"
                                label-cols-sm="6"
                                label-cols-md="4"
                                label-cols-lg="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    align="fill"
                                    size="sm"
                                    class="my-0"
                                ></b-pagination>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <!--         <b-input-group>
                        <b-button
                            v-if="!treated && checkRight('DeliveryCreate')"
                            size="sm"
                            @click="createNewItem"
                            class="mr-1"
                            ><font-awesome-icon icon="folder-plus" size="1x" />
                                        Extra behandeling
                        </b-button>
                    </b-input-group> -->
                </div>

                <b-table
                    :items="displayList"
                    :fields="visibleFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    stacked="md"
                    show-empty
                    :empty-text="$t('com_geen_data', { ns: 'common' })"
                    small
                    striped
                    @filtered="onFiltered"
                >
                    <template v-slot:cell(actions)="row">
                        <b-button
                            v-if="
                                !treated && checkRight('CheeseTreatmentUpdate')
                            "
                            size="sm"
                            @click="editItem(row.item)"
                            class="bgc_aux_warning"
                            ><font-awesome-icon icon="edit" size="1x" />
                        </b-button>
                        <b-button
                            v-if="checkRight('CheeseTreatmentCreate')"
                            size="sm"
                            @click="showRecipe(row.item)"
                            class="bgc_aux_unknown"
                            ><font-awesome-icon icon="info-circle" size="1x" />
                        </b-button>
                        <b-button
                            v-if="false && checkRight('CheeseTreatmentUpdate')"
                            size="sm"
                            @click="verwijderItem(row.item)"
                            class="bgc_aux_alarm"
                            ><font-awesome-icon icon="trash-alt" size="1x" />
                        </b-button>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <scan-barcode
            v-if="showScanner"
            v-model="showScanner"
            @result="setTreatmentActivity"
        />
        <confirm-treatment-modal
            v-if="detailsVisible"
            v-model="detailsVisible"
            :treatmentActivityId="currentID"
            :treatmentActivity="currentObject"
            :behandeling="currentBehandeling"
            @hide="reset"
            @change="applyChange"
        />
        <treatment-modal
            v-if="recipeVisible"
            v-model="recipeVisible"
            :treatmentRecipeId="recipeID"
            :batch="batchnummer"
            @hide="reset"
        />
    </b-container>
</template>

<script lang="ts">
import _ from 'lodash';
import PeriodSelector from '../components/PeriodSelector.vue';
import ScanBarcode from '../components/ScanBarcode.vue';
import ConfirmTreatmentModal from './ConfirmTreatmentModal.vue';
import TreatmentModal from './TreatmentModal.vue';
import { defineComponent } from 'vue';
import DateHelper from '@/models/DateHelper';
import { loadList, loadItem } from '../../models/DataHelper';
import { TreatmentActivity } from '@/models/CheeseTreatment';
import { Permission } from '../../models/Permissions';
import { VueExtension } from '../../models/VueExtension';

export default defineComponent({
    name: 'PlanTreatmentBase',
    data: function () {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: '',
            filterOn: [],
            currentID: -1,
            recipeID: -1,
            batchnummer: '',
            currentBehandeling: '',
            currentObject: {} as TreatmentActivity,
            detailsVisible: false,
            recipeVisible: false,
            treated: false,
            localItemslist: [],
            displayFilterCount: 20,
            aangeraakt: 0,

            showScanner: false,
            showDetails: false,
            van: null,
            tot: null,
            dag: 'day',
            isDagInfo: true,
            selectDays: null,
            periodeDagen: 1,
            editDagen: -4,
            forceRefresh: false,
            activitiesList: [] as Array<TreatmentActivity>,
            strNotInList: this.$t('prod_nietinlijst', {
                ns: 'production',
                val: this.$t('com_batch', { ns: 'common' })
            })
        };
    },
    props: {},
    components: {
        PeriodSelector,
        ScanBarcode,
        ConfirmTreatmentModal,
        TreatmentModal
    },
    computed: {
        title(): string {
            return this.treated
                ? this.$t('prod_behandeld', { ns: 'production' })
                : this.$t('prod_tebehandelen', { ns: 'production' });
        },
        btnTekst(): string {
            const res = this.$t('com_show', { ns: 'common' }) + ' ';
            const tant = this.treated
                ? this.$t('prod_tebehandelen', {
                      ns: 'production'
                  }).toLowerCase()
                : this.$t('prod_behandeld', { ns: 'production' }).toLowerCase();
            return res + tant;
        },
        showFilter(): boolean {
            return this.displayList
                ? this.displayList.length > this.displayFilterCount
                : false;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'id', sortable: false, visible: false },
                {
                    key: 'voorraaditemID',
                    label: this.$t('com_barcode', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'starttijd',
                    label: this.$t('prod_uitgevoerd', { ns: 'production' }),
                    sortable: true,
                    visible: this.treated,
                    formatter: 'displayDate'
                },
                {
                    key: 'starttijdplan',
                    label: this.$t('prod_gepland', { ns: 'production' }),
                    sortable: true,
                    visible: true,
                    formatter: 'displayDate'
                },
                {
                    key: 'product',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'batchnummer',
                    label: this.$t('prod_bakgroep', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'behandeling',
                    label: this.$t('prod_treatment', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'schema',
                    label: this.$t('prod_schema', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'stapnummer',
                    label: this.$t('prod_step', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'coatingproduct',
                    label: this.$t('prod_coating', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'locatie',
                    label: this.$t('com_location', { ns: 'common' }),
                    sortable: true,
                    //visible: !this.treated
                    visible: true
                },
                {
                    key: 'startaantal',
                    label: this.$t('com_number', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'statustekst',
                    label: this.$t('com_status', { ns: 'common' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        displayList() {
            const tempList = this.treated
                ? this.activitiesList.filter(
                      (x) => x.statusnummer >= window.constants.STATUS_TREATED
                  )
                : this.activitiesList.filter(
                      (x) => x.statusnummer < window.constants.STATUS_TREATED
                  );
            return tempList;
        },
        itemList() {
            return this.localItemslist;
        },
        allowEdit() {
            // todo: wat worden de regels hiervoor?
            const editDate = new Date();
            editDate.setDate(editDate.getDate() - this.editDagen);
            const tempDate = new Date(editDate).toISOString().substring(0, 10);
            //const magNog = this.van ? tempDate < this.van : true;
            return true;
        }
    },
    methods: {
        flipTreated() {
            this.treated = !this.treated;
            this.displayList;
        },
        createNewItem() {
            this.currentID = -1;
            this.detailsVisible = true;
        },
        scan() {
            this.showScanner = !this.showScanner;
        },
        editItem(item) {
            this.currentID = item ? parseInt(item.id) : -1;
            this.currentBehandeling = item.behandeling;
            this.currentObject = item;
            this.detailsVisible = true;
        },
        showRecipe(item) {
            this.recipeID = item ? parseInt(item.schemaID) : -1;
            this.batchnummer = item ? item.batchnummer : null;
            this.recipeVisible = true;
        },
        setTreatmentActivity(value) {
            if (value == undefined) return;
            const stockID = Number(value);
            const tacs = this.activitiesList.filter(
                (x) => x.voorraaditemID == stockID
            );
            if (tacs.length > 0) {
                // kunnen er niet veel zijn
                let step = 10000;
                let tac: TreatmentActivity = new TreatmentActivity();
                for (let i = 0; i < tacs.length; i++) {
                    if (tacs[i].stapnummer < step) {
                        step = tacs[i].stapnummer;
                        tac = tacs[i];
                    }
                }
                this.currentID = tac.id;
                this.currentObject = tac;
                this.currentBehandeling = tac.behandeling;
                this.detailsVisible = !this.detailsVisible;
            } else {
                // todo opzoeken in ander query
                (this.$root as VueExtension).showMessageBox(this.strNotInList);
            }
        },
        async applyChange(item) {
            if (item) {
                this.reset();
                this.forceRefresh = true;
                this.reloadData();
            }
        },
        async verwijderItem(item) {
            (this.$root as VueExtension)
                .showConfirmationBox(
                    'Zeker weten? Activiteit verwijderen: ' + item.id
                )
                .then(async (res) => {
                    if (res == true) {
                        const refreshedItem = await loadItem(
                            'delivery/loadDeliveryNote',
                            {
                                deliverynoteID: item.id
                            },
                            this.$t
                        );
                        const selectionData = {
                            id: refreshedItem.id,
                            lastupdated: refreshedItem.gewijzigd
                        };
                        await loadItem(
                            'delivery/deleteDeliveryNote',
                            selectionData,
                            this.$t
                        );
                    }
                    this.reloadData();
                });
        },
        reset() {
            this.currentID = -1;
            this.currentObject = {} as TreatmentActivity;    
            this.detailsVisible = false;
            this.recipeVisible = false;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        setNewDates(selDates) {
            const refreshData =
                this.van != selDates.van ||
                this.tot != selDates.tot ||
                this.dag != selDates.dag;
            this.van = selDates.van;
            this.tot = selDates.tot;
            this.dag = selDates.dag;
            this.isDagInfo = selDates.dag == 'day';
            if (refreshData) {
                this.forceRefresh = true;
                this.reloadData();
            }
        },
        async reloadData() {
            const tot = this.isDagInfo
                ? this.van
                : this.van && this.tot && this.van > this.tot
                ? this.van
                : this.tot;
            const selectionData = {
                from: DateHelper.localDateToUTC(this.van),
                until: DateHelper.localDateToUTC(tot)
            };
            const tempList = await loadList(
                'treatment/getPlannedTreatments',
                'treatment/loadPlannedTreatments',
                selectionData,
                this.forceRefresh,
                this.$t
            );
            tempList.forEach((t) => {
                this.$set(t, '_showDetails', false);
            });
            this.totalRows = tempList ? tempList.length : 0;
            this.activitiesList = tempList;
            this.forceRefresh = false;
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return (this.$root as VueExtension).handleRight(id);
        },
        displayDate(value) {
            return DateHelper.convertedToDate(value, true);
        }
    },
    mounted() {
        // Set the initial number of items
        this.reloadData();
        this.totalRows = this.displayList ? this.displayList.length : 0;
    },
    async created() {
        const lijst = await loadList(
            'masterdata/getConstantsLijst',
            'masterdata/loadApplicationConstants',
            null,
            this.forceRefresh,
            this.$t
        );
        const con = lijst
            ? lijst.find((x) => x.text == window.constants.APPCONST_EDITDAYS)
            : null;
        this.editDagen = con ? con.value : 30;
    }
});
</script>

<style scoped></style>

